// OBS Browser Source: сцена эфира — текущая тема, плашка говорящего, визуализация звука.

import { useEffect, useRef, useState } from 'preact/hooks';
import type { RoomState, ServerMessage } from '@besedka/shared';
import { api } from '../lib/api.js';
import { WsClient } from '../lib/ws.js';
import { connectAsListener, type LivekitHandle } from '../lib/livekit.js';

interface ObsInfo {
  livekitUrl: string;
  livekitToken: string;
  participants: { id: number; identity: string; displayName: string }[];
}

export function ObsOverlayPage({ episodeId }: { episodeId: number }) {
  const token = new URLSearchParams(location.search).get('token') || '';
  const [state, setState] = useState<RoomState | null>(null);
  const [speakers, setSpeakers] = useState<string[]>([]);
  const [info, setInfo] = useState<ObsInfo | null>(null);
  const [bars, setBars] = useState<number[]>(Array(16).fill(4));
  const livekitRef = useRef<LivekitHandle | null>(null);

  useEffect(() => {
    document.body.style.background = 'transparent';
    const ws = new WsClient(`?obs=${encodeURIComponent(token)}`);
    const off = ws.onMessage((message: ServerMessage) => {
      if (message.type === 'state.update') setState(message.state);
    });

    void api<ObsInfo>(`/api/obs/livekit?token=${encodeURIComponent(token)}`).then(async (data) => {
      setInfo(data);
      livekitRef.current = await connectAsListener(
        data.livekitUrl,
        data.livekitToken,
        { onSpeakers: setSpeakers },
        () => false // overlay не играет звук — только события
      );
    }).catch(() => {});

    // Простая «дышащая» визуализация, реагирует на наличие говорящих
    const timer = window.setInterval(() => {
      setBars((prev) => prev.map(() => 4 + Math.random() * (speakersRef.current.length ? 52 : 8)));
    }, 120);

    return () => {
      off();
      ws.close();
      livekitRef.current?.disconnect();
      window.clearInterval(timer);
    };
  }, [episodeId, token]);

  const speakersRef = useRef<string[]>([]);
  speakersRef.current = speakers;

  const currentTopic = state?.timeline.filter((t) => t.endMs === null).at(-1) || state?.timeline.at(-1);
  const speakingNames = (info?.participants || [])
    .filter((p) => speakers.includes(p.identity))
    .map((p) => p.displayName);

  return (
    <div class="obsOverlay">
      <div class="obsViz">
        {bars.map((height, i) => (
          <div key={i} style={{ height: `${height}px` }} />
        ))}
      </div>
      {currentTopic && <div class="obsTopic">{currentTopic.title}</div>}
      {speakingNames.length > 0 && <div class="obsSpeakerBadge">🎙 {speakingNames.join(', ')}</div>}
    </div>
  );
}
